/** @jsxImportSource @emotion/react */
import React, { ReactNode, useState } from "react";
import { Banner } from "../BannerSection/Banner";
import { Header } from "../Header/Header";
import { HostEnvironments } from "../../config/env";
import { GlobalStore } from "../../store/global/GlobalStore";
import { Theme } from "styles/theme";
import styled from "@emotion/styled";
import { SideNav } from "components/NavbarV2/elements/SideNav";
import Footer from "./elements/Footer";

interface LayoutProps {
  children?: ReactNode;
  isNotFound?: boolean;
}

export const HomeLayout: React.FC<LayoutProps> = props => {
  const theme = GlobalStore.useState(s => s.theme);
  const [isSideNavOpen, setIsSideNavOpen] = useState(false);

  return (
    <LayoutContainer theme={theme}>
      <LayoutContentContainer>
        <Banner isVisible={window.location.host === HostEnvironments.BETA} />
        <Header setIsSideNavOpen={setIsSideNavOpen} />

        {props.children}

        <SideNav isOpen={isSideNavOpen} setIsOpen={setIsSideNavOpen} />

        <Footer />
      </LayoutContentContainer>
    </LayoutContainer>
  );
};

// Sub-components

interface LayoutContainerProps {
  theme: Theme;
}

export const LayoutContainer = styled.div<LayoutContainerProps>`
  position: relative;
  width: 100%;
  font-weight: 300;
  overflow: hidden;
  background-attachment: fixed;
  font-family: agenda-one;
  letter-spacing: 0;
  background-position: 60% 35%;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100vh;
`;

export const LayoutContentContainer = styled.div`
  min-height: 100vh;

  @media (max-width: 420px) {
    min-height: calc(100vh * 0.8);
  }
`;
